// src/linear/check.tsx
import { jsx } from "react/jsx-runtime";
var CheckLinearIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "aria-hidden": "true",
    fill: "none",
    focusable: "false",
    height: "1em",
    role: "presentation",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    ...props,
    children: /* @__PURE__ */ jsx("polyline", { points: "20 6 9 17 4 12" })
  }
);

export {
  CheckLinearIcon
};
